import suggestionsRegex from "./suggestions/suggestionsRegex";
import Suggestions from "./suggestions/Suggestions";

const excludeEntities = character => !character.getEntity();

const findSuggestions = (contentBlock, callback) => {
  const blockText = contentBlock.getText();

  contentBlock.findEntityRanges(excludeEntities, (textStart, textEnd) => {
    const text = blockText.slice(textStart, textEnd);
    let matchData = suggestionsRegex.exec(text);
    if (matchData) {
      const query = matchData[0].split(" ").slice(0, 2).join(" ");
      matchData[0] = query.trim();
    }
    let start;

    while (matchData !== null) {
      start = textStart + matchData.index;
      callback(start, start + matchData[0].length);
      matchData = suggestionsRegex.exec(text);
    }
  });
};

const makeSuggestionsDecorator = props => ({
  strategy: findSuggestions,
  component: Suggestions,
  props
});

export default makeSuggestionsDecorator;
